import React from "react";
import {
  Flex,
  Box,
  InputGroup,
  InputLeftAddon,
} from "@chakra-ui/react";
import DatePicker from "../common/date-picker/DatePicker";

function LabledDatePicker({selected,onChange,label='',validationClass='',...props}) {
  return (
    <>
      <Flex direction="column">
        <InputGroup>
          <InputLeftAddon mr={-.5} fontSize=".8rem" children={label} borderColor={'rgb(94,94,114,.3)'} />
          <Box
            className={validationClass}
          >
            <DatePicker
              selected={selected}
              showPopperArrow={true}
              onChange={onChange}
              {...props}
            />
          </Box>
        </InputGroup>
      </Flex>
    </>
  );
}

export default LabledDatePicker;


